// Initial quick-add requests yield to newer supported overlay actions, without hiding
// another overlay or cancelling its variant-selection requests.
const quickAddOverlayIntent = {
  current: null,
  claim(owner = null) {
    const intent = { owner };
    this.current = intent;
    document.querySelectorAll('quick-add-modal').forEach(modal => {
      if (modal !== owner) modal.cancelInitialLoad?.();
    });
    return intent;
  }
};

document.addEventListener('click', event => {
  const target = event.target.closest?.('#cart-icon-bubble, #cart-icon-sticky-bubble, #fixed-cart-icon-bubble, .header-mobile--search .search__button, [data-otf-guide-target], pickup-availability[available] button');
  if (!target || target.disabled || target.getAttribute('aria-disabled') === 'true') return;
  if (target.matches('#cart-icon-bubble, #cart-icon-sticky-bubble, #fixed-cart-icon-bubble') && !document.querySelector('cart-popup')) return;
  quickAddOverlayIntent.claim();
}, true);
document.addEventListener('keydown', event => {
  const cart = event.target.closest?.('#cart-icon-bubble, #cart-icon-sticky-bubble, #fixed-cart-icon-bubble');
  if (event.key === 'Escape' || event.code === 'Escape' || (event.code?.toUpperCase() === 'SPACE' && cart && document.querySelector('cart-popup'))) quickAddOverlayIntent.claim();
}, true);
['focusin', 'input'].forEach(type => document.addEventListener(type, event => {
  if (event.target.id === 'Mobile-Search-In-Modal') quickAddOverlayIntent.claim();
}, true));

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  ).filter(element => element.getClientRects().length > 0 && !element.closest('[inert]'));
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    $(document).find('.disclosure__list-wrapper').attr('hidden', true);
    if(summary.hasAttribute('data-header-nav')){
      $(document).find('.section-header').toggleClass('header__overlay');
      if($('header-menu').find('details[open]').length == 0) {
        $(document).find('.section-header').addClass('header__overlay');
      }
    }
    if(window.matchMedia("(min-width: 990px)").matches){
      if($(summary).hasClass('mobile-facets__summary') && $(summary).hasClass('filter__availability')){
        return false;
      }
      if($(summary).hasClass('mobile-facets__summary')){
        $(document).find('.mobile-facets__details:not(.fixed-area__details)').removeAttr('open');
      }
    }
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

document.onreadystatechange = function () {
  if (document.readyState === "complete") {
    setTimeout(function(){
      if(document.querySelector('.theme-loader__progress')){
        document.querySelector('body').classList.remove('loader__overflow');
        document.querySelector('.theme-loader__progress').style.display = 'none';
      }
    },1000);
  } 
};

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0] || container;
  var last = elements[elements.length - 1] || container;
  if (!elementToFocus || (elementToFocus !== container && !elementToFocus.getClientRects().length)) elementToFocus = first;

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia(currentVideoId = null) {
  document.querySelectorAll('.js-youtube[playonclick]').forEach((video) => {
      video.contentWindow.postMessage(
        '{"event":"command","func":"pauseVideo","args":""}','*'
      );
  });
  document.querySelectorAll('.js-vimeo[playonclick]').forEach((video) => {
    if (video.dataset.mediaId !== currentVideoId) {
      video.contentWindow.postMessage('{"method":"pause"}', '*'
      );
    }
  });
  document.querySelectorAll('video[playonclick]').forEach((video) => {
      video.pause();
  });
  document.querySelectorAll('product-model[playonclick]').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}




function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;
  // Facet drawers own Escape cleanup, including body lock and popup ownership.
  if (event.target.closest('menu-drawer.mobile-facets__wrapper')) return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.currentTarget.disabled) return;
    event.currentTarget.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = Number(this.input.value);
    const min = this.input.min === '' ? null : Number(this.input.min);
    const max = this.input.max === '' ? null : Number(this.input.max);
    const minus = this.querySelector(".quantity__button[name='minus']");
    const plus = this.querySelector(".quantity__button[name='plus']");
    [[minus, min !== null && value <= min], [plus, max !== null && value >= max]].forEach(([button, disabled]) => {
      if (!button) return;
      button.classList.toggle('disabled', disabled);
      button.disabled = disabled;
    });
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}
function customJavascript() {
  $(window).on("load", function () {
    let checkAgeVerified = true;
    let checkAgePopupCockie = getCookie("age-verification");
    if (
      $(document).find('[data-popup-type="age-verification"]').length &&
      checkAgePopupCockie == ""
    ) {
      checkAgeVerified = false;
      if (
        $(document)
          .find('[data-popup-type="age-verification"]')
          .hasClass("hide-popup")
      ) {
        $(document)
          .find('[data-popup-type="age-verification"]')
          .removeClass("hide-popup");
        $(document).find("body").attr("active-popup", 'age-verification');
        $(document).find(".theme-popup-overlay").removeClass("hidden-overlay");
      }
    }

    if (checkAgeVerified == true) {
      let checkWelcomePopupCockie = getCookie("welcome-popup");
      let popupDelayTime = $(document)
        .find('[data-popup-type="welcome"]')
        .data("popup-delay");
      if (checkWelcomePopupCockie == "") {
        setTimeout(function () {
          if (
            $(document)
              .find('[data-popup-type="welcome"]')
              .hasClass("hide-popup")
          ) {
            $(document)
              .find('[data-popup-type="welcome"]')
              .removeClass("hide-popup");
            $(document).find("body").attr("active-popup", 'welcome');
            $(document).find(".theme-popup-overlay").removeClass("hidden-overlay");
          }
        }, popupDelayTime);
      }
    }
  });

  $(document).ready(function () {
    $('body').on('click', function(event) {
      const targetElement = event.target;
      const targetClasses = targetElement.classList;
      if (targetClasses.contains('disclosure__button') || targetClasses.contains('country-flag') || targetClasses.contains('arrow--down')) {}else{
        $(document).find('.disclosure__button[aria-expanded="true"]').attr('aria-expanded',false);
        $(document).find('.disclosure__list-wrapper').attr('hidden', true);
      }
    });
    $(document).on("click", ".btn-back-to-top", function () {
      $("html, body").animate({ scrollTop: 0 });
    });
    $(window).on("scroll", function () {
      if ($(this).scrollTop() > 350) {
        $(document).find(".fixed-scroll-top-btn").removeClass("hide");
      } else {
        $(document).find(".fixed-scroll-top-btn").addClass("hide");
      }
    });
    $(document).on("click", ".popup--button", function (event) {
      event.preventDefault();
      quickAddOverlayIntent.claim();
      let modalType = $(this).data("modal-type");
      if(!$(document).find('.rt-theme-popup[data-popup-type="' + modalType + '"]').hasClass('hide-popup')){
        $(document).find('.rt-theme-popup[data-popup-type="' + modalType + '"]').addClass("hide-popup");
        $(document).find(".theme-popup-overlay").addClass("hidden-overlay");
        $(document).find("body").removeAttr("active-popup");
        return false;
      }
      $(document).find('.rt-theme-popup').addClass("hide-popup");
      $(document).find(".theme-popup-overlay").removeClass("hidden-overlay");
      setTimeout(function () {
        $(document).find('.rt-theme-popup[data-popup-type="' + modalType + '"]').find('.field>input').first().focus();
      }, 100);
      $(document).find('.rt-theme-popup[data-popup-type="' + modalType + '"]').removeClass("hide-popup");
      $(document).find("body").attr("active-popup", modalType);
    });
    $(document).on("click", ".header-additional__toggle-link", function (event) {
      quickAddOverlayIntent.claim();
      let modalType = $(this).data("modal-type");
      $(document).find(".section-header").addClass("header__overlay");
      $(document).find('.overlay-navigation-panel__popup[data-popup-type="' + modalType + '"]').removeClass("hide-popup");
      $(document).find("body").attr("active-popup", modalType);
    });
    $(document).on("click", ".btn--page-reload", function (event) {
      event.preventDefault();
      window.location.href = "https://google.com/";
    });
    $(document).on("click", ".btn--age-verified", function (event) {
      event.preventDefault();
      let redirectLink = $(document)
        .find('[data-popup-type="age-verification"]')
        .data("redirect");
      let showAgainAgePopup = $(document)
        .find('[data-popup-type="age-verification"]')
        .data("show-popup-again");
      setCookie("age-verification", true, showAgainAgePopup);
      $(document).find("body").removeAttr("active-popup");
      if (redirectLink == false) {
        $(document).find(".theme-popup-overlay").addClass("hidden-overlay");
        $(document).find(".rt-theme-popup").addClass("hide-popup");
      } else {
        window.location.href = redirectLink;
      }
    });
    $(document).on(
      "click",
      ".theme-popup-overlay,.theme-popup-close,.theme-menu-popup-overlay,.popup-close__btn",
      function (event) {
        quickAddOverlayIntent.claim();
        document.querySelectorAll('quick-add-modal:not(.hide-popup)').forEach(modal => modal.hide());
        document.querySelectorAll('menu-drawer.mobile-facets__wrapper').forEach(drawer => {
          const summary = drawer.mainDetailsToggle.querySelector('summary');
          if (summary.getAttribute('aria-expanded') === 'true') drawer.closeMenuDrawer(event, summary);
        });
        if ($(document).find('[data-popup-type="age-verification"]').length) {
          if (
            $(document)
              .find('[data-popup-type="age-verification"]')
              .hasClass("hide-popup")
          ) {
            event.preventDefault();
            if (
              $(document).find('[data-popup-type="welcome"]').length &&
              !$(document)
                .find('[data-popup-type="welcome"]')
                .hasClass("hide-popup")
            ) {
              let showAgainPopup = $(document)
                .find('[data-popup-type="welcome"]')
                .data("show-popup-again");
              setCookie("welcome-popup", true, showAgainPopup);
            }
            $(document).find(".theme-popup-overlay").addClass("hidden-overlay");
            $(document)
              .find(".cart--popup-recommandation")
              .removeClass("recommandation-active");
            $(document).find(".section-header").removeClass("header__overlay");
            $(document).find(".rt-theme-popup,.overlay-navigation-panel__popup").addClass("hide-popup");
            $(document).find(".cart--popup-quick-add").removeClass("active");
          }
        } else {
          event.preventDefault();
          if (
            $(document).find('[data-popup-type="welcome"]').length &&
            !$(document)
              .find('[data-popup-type="welcome"]')
              .hasClass("hide-popup")
          ) {
            let showAgainPopup = $(document)
              .find('[data-popup-type="welcome"]')
              .data("show-popup-again");
            setCookie("welcome-popup", true, showAgainPopup);
          }
          $(document)
            .find(".cart--popup-recommandation")
            .removeClass("recommandation-active");
          $(document).find(".theme-popup-overlay").addClass("hidden-overlay");
          $(document).find(".section-header").removeClass("header__overlay");
         $(document).find(".rt-theme-popup,.overlay-navigation-panel__popup").addClass("hide-popup");
          $(document).find(".cart--popup-quick-add").removeClass("active");
          setTimeout(function(){
             $(document).find("quick-add-modal.hide-popup .quick-add-modal__content-info").empty();
          },1000);
        }
        setTimeout(function(){
          $(document).find("menu-drawer:not(.mobile-facets__wrapper)").find('.menu-opening').removeClass('menu-opening').removeAttr("open");
        },500);
        $(document).find("body").removeAttr("active-popup");
      }
    );
    if ($(document).find(".card__content").length) {
      $(".card__content").hover(function (e) {
        if (this.closest('.main-blog')) return;
        if (window.matchMedia('(min-width: 990px)').matches) {
          e.stopPropagation();
          if(!$(this).hasClass('empty--image')){
            $(this).find(".article--excert").slideToggle(300);
            $(this).find(".collection-view__button").slideToggle(300);
          }
        }
      });
    }

    function updateProductCardImage(closeElement, variantMediaStr, secondaryMediaStr) {
      if (window.otfCardPhotos && window.otfCardPhotos.update(closeElement[0], variantMediaStr, secondaryMediaStr)) return;
      try {
        var variantMedia = variantMediaStr ? JSON.parse(variantMediaStr) : null;

        if (!variantMedia) return;

        var imageSize = closeElement.find(".media img:first").attr("sizes");
        var imagePrimary = createImageElement(variantMedia, "motion-reduce", imageSize);
        var mediaWrapper = closeElement.find(".media");

        mediaWrapper.html(imagePrimary);
      window.otfCustomCardPhotos?.update(closeElement[0]);
        // S09c (2026-10-26): a declined card never gets a second photo appended; only approved exact-colour sets show one.
      } catch (e) {
        console.error("Media parsing error:", e);
      }
    }

    // Product-card links: only "variant" and "otf_color" are ever replaced. Every other
    // parameter (search position and the like) and any #anchor stay exactly as written.
    function otfCardLinkUrl(url, key, value) {
      var text = String(url || "");
      var hashAt = text.indexOf("#");
      var anchor = hashAt === -1 ? "" : text.slice(hashAt);
      var main = hashAt === -1 ? text : text.slice(0, hashAt);
      var queryAt = main.indexOf("?");
      var path = queryAt === -1 ? main : main.slice(0, queryAt);
      var kept = (queryAt === -1 ? "" : main.slice(queryAt + 1)).split("&").filter(function (field) {
        var name = field.split("=")[0];
        return field !== "" && name !== "variant" && name !== "otf_color";
      });
      if (key) kept.push(key + "=" + encodeURIComponent(value));
      return path + (kept.length ? "?" + kept.join("&") : "") + anchor;
    }

    $(document).on("change", ".radio-card-swatch", function () {
      var closeElement = $(this).parents(".product-grid-item");
      var variantId = $(this).attr("data-variant-id");
      var variantMediaStr = $(this).attr("data-variant-media");
      var variantSecondaryMediaStr = $(this).attr("data-variant-secondary-media");
      var productUrl = $(this).attr("data-product-url");
      var colorId = $(this).attr("data-otf-color-id");
      var cardUrl = closeElement.attr("data-url");
      var selectedUrl = '';

      if (productUrl) {
        // Combined listing: this color is a product of its own.
        selectedUrl = productUrl;
      } else if (cardUrl && $(this).attr("data-otf-size-required") !== "false") {
        // A size is still to be chosen: the link keeps the color and never carries a size-bearing variant.
        selectedUrl = otfCardLinkUrl(cardUrl, colorId ? "otf_color" : "", colorId);
      } else if (cardUrl && variantId) {
        // No size to choose (one size, or no size option): the color is the whole choice.
        selectedUrl = otfCardLinkUrl(cardUrl, "variant", variantId);
      }
      if (selectedUrl) {
        closeElement.find('.media-full-unstyled-link, .card__heading a, .color__more a, a.quick-add__submit').attr('href', selectedUrl);
        closeElement.find('modal-opener button[data-product-url]').attr('data-product-url', selectedUrl);
      }

      updateProductCardImage(closeElement, variantMediaStr, variantSecondaryMediaStr);
    });
    // Reload or Back can restore a checked color without firing its change event; replay it once so the image and links match the color shown.
    $(".radio-card-swatch:checked").each(function () {
      if (!this.defaultChecked) this.dispatchEvent(new Event("change", { bubbles: true }));
    });
    const otfFooterAccordionMobile = window.matchMedia('(max-width: 749px)');
    const otfFooterAccordionSelector = '.footer .footer-block.accordion > .footer__block-toggle[aria-controls]';
    let otfFooterAccordionLastMobile = otfFooterAccordionMobile.matches;

    function syncFooterAccordions(root = document) {
      if (root === document) otfFooterAccordionLastMobile = otfFooterAccordionMobile.matches;
      root.querySelectorAll(otfFooterAccordionSelector).forEach((button) => {
        const panel = document.getElementById(button.getAttribute('aria-controls'));
        if (!panel || panel !== button.nextElementSibling) return;
        $(panel).stop(true, true);
        const expanded = !otfFooterAccordionMobile.matches || button.parentElement.classList.contains('active');
        if (otfFooterAccordionMobile.matches) {
          $(panel).toggle(expanded);
        } else {
          panel.style.removeProperty('display');
        }
        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    }

    syncFooterAccordions();
    otfFooterAccordionMobile.addEventListener('change', () => syncFooterAccordions());
    window.addEventListener('resize', () => {
      if (otfFooterAccordionMobile.matches !== otfFooterAccordionLastMobile) syncFooterAccordions();
    });
    document.addEventListener('shopify:section:load', (event) => syncFooterAccordions(event.target));

    $(document).on("click", ".accordion__toggle-btn", function (event) {
      event.preventDefault();
      const isFooterAccordion = this.matches(otfFooterAccordionSelector);
      if (isFooterAccordion) {
        if (!otfFooterAccordionMobile.matches) {
          syncFooterAccordions(this.parentElement);
          return;
        }
        $(this).next('*').stop(true, true);
      }
      $(this).parent('*').addClass('current__panel');
      $(document).find('.collapsible-panel__grid-right').find('.accordion.active:not(.current__panel)').removeClass('active').find('.accordion__content-rte').slideUp(450);
      $(this).next("*").slideToggle(450).parent("*").toggleClass("active");
      if (isFooterAccordion) {
        this.setAttribute('aria-expanded', this.parentElement.classList.contains('active') ? 'true' : 'false');
      }
      $(this).parent('*').removeClass('current__panel');
    });
    $(document).on("click", ".shop-the__look-dots", function () {
      var thisId = $(this).data("id");
      var parentDiv = $(this).parents(".shop-the__look-inner");
      parentDiv.find(".shop-the__look-dots").removeClass("selected");
      $(this).addClass("selected");
      parentDiv
        .find("slider-component")
        .find('.slider-counter__link--dots[data-id="' + thisId + '"]')
        .trigger("click");
      parentDiv
        .find("slider-component")
        .find(".slider__slide")
        .addClass("mobile_tablet--hide");
      parentDiv
        .find("slider-component")
        .find('.slider__slide[data-id="' + thisId + '"]')
        .removeClass("mobile_tablet--hide");
    });
    $(document).on('click','.btn-newsletter__submit',function(event){
      event.preventDefault();
      var _form = $(this).closest('form');
      var email = _form.find('input[type="email"]').val();
      var warning = _form.find('.theme--error-message').find('svg').prop('outerHTML');
      var emailInput = _form.find('input[type="email"]')[0];
      if(email == ''){
         _form.find('.theme--error-message').removeClass('hide').html(warning+"Email can't be blank");
      }else if (emailInput && emailInput.checkValidity()) {
        _form.find('.theme--error-message').addClass('hide');
        _form.submit();
      } else {
        if(_form.find('.theme--error-message').length){
          _form.find('.theme--error-message').removeClass('hide').html(warning+"Please enter a valid email address");
        }
      }
    });
  });
}

/*
 * Image Comparison
 *
 */
const imageDiversion = class extends HTMLElement {
  connectedCallback() {
    this.b = this.closest(".shopify-section");
    this.c = this.d = false;
    this.e = this.f = 0;
    
    this.g = (event) => this.h(event);
    this.i = (event) => this.j(event);
    this.k = () => this.l();
    this.m = () => this.n();
    
    this.b.addEventListener("pointerdown", this.g);
    this.b.addEventListener("pointermove", this.i);
    this.b.addEventListener("pointerup", this.k);
    window.addEventListener("resize", this.m);
  }
  get o() {
    return -this.offsetLeft;
  }
  get p() {
    const offsetParent = this.offsetParent;
    return offsetParent ? offsetParent.clientWidth + this.o : 0;
  }

  h(event) {
    if (event.target === this || this.contains(event.target)) {
      this.q = event.clientX - this.e;
      this.c = true;
    }
  }
  j(event) {
    if (!this.c) {
      return;
    }
    this.f = Math.min(Math.max(event.clientX - this.q, this.o), this.p);
    this.e = this.f;
    this.b.style.setProperty("--image-diversion-offset", `${this.f.toFixed(1)}px`);
  }
  l() {
    this.c = false;
  }
  n() {
    this.b.style.setProperty("--image-diversion-offset", `${Math.min(Math.max(this.o, this.f.toFixed(1)), this.p)}px`);
  }
};

if (!window.customElements.get("image-diversion")) {
  window.customElements.define("image-diversion", imageDiversion);
}


/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    this.boundSummaryClick = this.onSummaryClick.bind(this);
    this.boundCloseButtonClick = this.onCloseButtonClick.bind(this);

    if (this.classList.contains('mobile-facets__wrapper')) {
      this.addEventListener('toggle', (event) => {
        const details = event.target;
        if (details.tagName !== 'DETAILS' || details.closest('menu-drawer') !== this) return;
        const summary = Array.from(details.children).find(child => child.tagName === 'SUMMARY');
        if (summary) summary.setAttribute('aria-expanded', details.open);
      }, true);
    }

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => {
      if (this.classList.contains('mobile-facets__wrapper') && summary.closest('menu-drawer') === this) {
        summary.setAttribute('role', 'button');
        summary.setAttribute('aria-expanded', summary.parentElement.hasAttribute('open'));
        if (summary.nextElementSibling?.id) summary.setAttribute('aria-controls', summary.nextElementSibling.id);
      }
      summary.removeEventListener('click', this.boundSummaryClick);
      summary.addEventListener('click', this.boundSummaryClick);
    });
    this.querySelectorAll('button').forEach(button => {
      button.removeEventListener('click', this.boundCloseButtonClick);
      button.addEventListener('click', this.boundCloseButtonClick);
    });
  }

  cancelPendingFacetNestedOpen() {
    this.facetNestedTimers?.forEach(timer => clearTimeout(timer));
    this.facetNestedTimers?.clear();
    this.facetNestedTransitions?.forEach(({ submenu, listener }) => submenu.removeEventListener('transitionend', listener));
    this.facetNestedTransitions?.clear();
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    if(window.matchMedia("(min-width: 990px)").matches){
      if($(summaryElement).hasClass('mobile-facets__summary') && $(summaryElement).hasClass('filter__availability')){
        return false;
      }
      if($(summaryElement).hasClass('mobile-facets__summary')){
        $(document).find('.mobile-facets__details:not(.fixed-area__details)').removeAttr('open');
      }
    }
    const facetCycle = this.classList.contains('mobile-facets__wrapper') ? this.facetCycle : null;
    const submenu = summaryElement.nextElementSibling;
    const facetIsCurrent = () => facetCycle === null || (
      facetCycle === this.facetCycle && this.isConnected && this.mainDetailsToggle.hasAttribute('open') &&
      detailsElement.isConnected && summaryElement.isConnected && submenu?.isConnected &&
      this.contains(detailsElement) && summaryElement.parentElement === detailsElement &&
      summaryElement.nextElementSibling === submenu && detailsElement.contains(submenu) &&
      detailsElement.hasAttribute('open') &&
      (!parentMenuElement || (parentMenuElement.isConnected && this.contains(parentMenuElement)))
    );
    const addTrapFocus = () => {
      submenu?.removeEventListener('transitionend', addTrapFocus);
      this.facetNestedTransitions?.forEach(entry => {
        if (entry.listener === addTrapFocus) this.facetNestedTransitions.delete(entry);
      });
      if (!facetIsCurrent()) return;
      const focusContainer = detailsElement.closest('.facets-popup__filter') || submenu;
      trapFocus(focusContainer, detailsElement.querySelector('button'));
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)').matches) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      } else {
        document.documentElement.style.removeProperty('--viewport-height');
      }
    } else {
      if (facetCycle !== null) this.cancelPendingFacetNestedOpen();
      let timer;
      timer = setTimeout(() => {
        this.facetNestedTimers?.delete(timer);
        if (!submenu || !facetIsCurrent()) return;
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        // Facet accordions retain the popup trap and the shopper's current focus.
        if (facetCycle !== null) return;
        if (!reducedMotion || reducedMotion.matches) addTrapFocus();
        else {
          submenu.addEventListener('transitionend', addTrapFocus);
          if (facetCycle !== null) (this.facetNestedTransitions ||= new Set()).add({ submenu, listener: addTrapFocus });
        }
      }, 100);
      if (facetCycle !== null) (this.facetNestedTimers ||= new Set()).add(timer);
    }
  }

  openMenuDrawer(summaryElement) {
    quickAddOverlayIntent.claim(this);
    const facetCycle = this.classList.contains('mobile-facets__wrapper') ? (this.facetCycle = (this.facetCycle || 0) + 1) : null;
    if (facetCycle !== null) this.cancelPendingFacetNestedOpen();
    clearTimeout(this.facetCloseTimer);
    this.facetCloseTimer = null;
    setTimeout(() => {
      if (facetCycle !== null && (facetCycle !== this.facetCycle || !this.isConnected)) return;
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    if($(this).hasClass('mobile-facets__wrapper')){
      clearTimeout(this.facetOpenTimer);
      if (window.matchMedia('(max-width: 989px)').matches) {
        // Reset once per main-dialog open, never during an AJAX selection or nested-panel open.
        this.querySelectorAll('.facets-popup__filter .popup--inner, .facets-popup__filter .mobile-facets__main, .facets-popup__filter .otf-facet-values').forEach(node => {
          node.scrollTop = 0;
          node.scrollLeft = 0;
        });
      }
      if(window.matchMedia("(min-width: 990px)").matches){
        $(document).find('.fixed-area__details').attr('open', true);
        $(document).find('.mobile-facets__details:not(.fixed-area__details):first').attr('open', true);
      }
      this.facetOpenTimer = setTimeout(() => {
         this.facetOpenTimer = null;
         const filterPopup = this.querySelector('.facets-popup__filter');
         if (!this.mainDetailsToggle.hasAttribute('open')) return;
         filterPopup.classList.remove('hide-popup');
         $(document).find("body").attr("active-popup", 'filter-popup');
         $(document).find(".theme-popup-overlay").removeClass("hidden-overlay");
         trapFocus(filterPopup, filterPopup.querySelector('.theme-popup-close'));
      },100);
    }
    summaryElement.setAttribute('aria-expanded', true);
    if (!this.classList.contains('mobile-facets__wrapper')) trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;
    const facetCycle = this.classList.contains('mobile-facets__wrapper') ? (this.facetCycle = (this.facetCycle || 0) + 1) : null;
    if (facetCycle !== null) this.cancelPendingFacetNestedOpen();
    clearTimeout(this.facetOpenTimer);
    this.facetOpenTimer = null;
    if (facetCycle !== null && document.body.getAttribute('active-popup') === 'filter-popup') {
      document.body.removeAttribute('active-popup');
    }

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
      if (facetCycle !== null) details.querySelector('summary')?.setAttribute('aria-expanded', false);
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    // Close the native facet state immediately so a rapid second tap reopens it.
    if (facetCycle !== null) this.mainDetailsToggle.removeAttribute('open');
    else this.closeAnimation(this.mainDetailsToggle);
    if($(this).hasClass('mobile-facets__wrapper')){
      clearTimeout(this.facetCloseTimer);
      this.facetCloseTimer = setTimeout(() => {
         this.facetCloseTimer = null;
         if (facetCycle !== this.facetCycle || !this.isConnected) return;
         this.querySelector('.facets-popup__filter')?.classList.add('hide-popup');
         if (!document.body.hasAttribute('active-popup')) document.querySelector('.theme-popup-overlay')?.classList.add('hidden-overlay');
      },100);
    }
  }

  disconnectedCallback() {
    this.cancelPendingFacetNestedOpen();
    clearTimeout(this.facetOpenTimer);
    clearTimeout(this.facetCloseTimer);
    this.facetOpenTimer = null;
    this.facetCloseTimer = null;
    this.facetCycle = (this.facetCycle || 0) + 1;
    if (this.classList.contains('mobile-facets__wrapper') && this.mainDetailsToggle.hasAttribute('open') && (!document.body.hasAttribute('active-popup') || document.body.getAttribute('active-popup') === 'filter-popup')) {
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      if (document.body.getAttribute('active-popup') === 'filter-popup') document.body.removeAttribute('active-popup');
      removeTrapFocus();
      document.querySelector('.theme-popup-overlay')?.classList.add('hidden-overlay');
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    if (detailsElement === this.mainDetailsToggle) {
      this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'));
      return;
    }
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    if (this.classList.contains('mobile-facets__wrapper')) {
      const popup = detailsElement?.closest('.facets-popup__filter');
      const summary = detailsElement?.querySelector('summary');
      if (!this.isConnected || !this.mainDetailsToggle.hasAttribute('open') ||
        !detailsElement?.isConnected || !popup?.isConnected || !summary?.isConnected ||
        !this.contains(popup) || !popup.contains(detailsElement) ||
        detailsElement.closest('menu-drawer') !== this ||
        summary.parentElement !== detailsElement) return;
      this.cancelPendingFacetNestedOpen();
      detailsElement.closest('.submenu-open')?.classList.remove('submenu-open');
      detailsElement.classList.remove('menu-opening');
      detailsElement.removeAttribute('open');
      summary.setAttribute('aria-expanded', false);
      removeTrapFocus(summary);
      trapFocus(popup, summary);
      return;
    }
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;
    const facetCycle = this.classList.contains('mobile-facets__wrapper') ? this.facetCycle : null;

    const handleAnimation = (time) => {
      if (facetCycle !== null && (facetCycle !== this.facetCycle || !this.isConnected)) return;
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        if(!$(detailsElement).hasClass('menu-drawer-container')){
          detailsElement.removeAttribute('open');
        }
        if (detailsElement.closest('details[open]')) {
          const focusContainer = detailsElement.closest('.facets-popup__filter') || detailsElement.closest('details[open]');
          trapFocus(focusContainer, detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

$(document).on('click','.dropdown-menu--toggle',function(){
  $(this).toggleClass('menu-expanded');
  if (this.hasAttribute('aria-controls')) this.setAttribute('aria-expanded', this.classList.contains('menu-expanded') ? 'true' : 'false');
});

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    if (this.localName !== 'quick-add-modal') quickAddOverlayIntent.claim(this);
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    if($(this).hasClass('rt-theme-popup')){
      $(this).removeClass('hide-popup');
      $(document).find('.theme-popup-overlay').removeClass('hidden-overlay');
      $(document).find("body").attr("active-popup", 'product-model');
    }else{
      document.body.classList.add('overflow-hidden');
      this.setAttribute('open', '');
    }
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  onClick(event) {
    const button = event.target.closest?.('button');
    if (!button || button.closest('modal-opener') !== this || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
    const selector = this.getAttribute('data-modal');
    if (!selector) return;
    const modal = document.querySelector(selector);
    if (typeof modal?.show !== 'function') return;
    event.preventDefault();
    modal.show(button);
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    const autoplay = this.dataset.autoplay;
    if (!poster) return;
    if (autoplay == 'true') {
      this.loadContent('autoplay');
      const videoImage = this.querySelector('video img');
      if(videoImage){
        videoImage.setAttribute("alt",'');
      }
    }
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(item,focus = true) {
    if(item == 'autoplay'){
      focus = false;
    }
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
       if(item == 'autoplay'){
         deferredElement.muted = true;
         deferredElement.play();
       }else{
         deferredElement.play();
       }
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    
    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    	
    this.sliderControlWrapper = this.querySelector('.slider-buttons');	
    if (!this.sliderControlWrapper) return;	
    this.sliderFirstItemNode = this.slider.querySelector('.slider__slide');	
    	
    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));	
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    
    if (this.slider.getAttribute('data-autoplay') === 'true'){
      this.setAutoPlay();
    }else if (this.slider.getAttribute('data-autoplay') === 'desktop') {
      if(window.matchMedia("(min-width: 750px)").matches){
        this.setAutoPlay();
      }
    }else if (this.slider.getAttribute('data-autoplay') === 'mobile') {
      if(window.matchMedia("(max-width: 749px)").matches){
        this.setAutoPlay();
      } 
    }
  }
  
  setAutoPlay() {
    if(window.matchMedia("(min-width: 750px)").matches){
      this.autoplaySpeed = this.slider.getAttribute('data-speed-desktop') * 1000;
    }else{
      this.autoplaySpeed = this.slider.getAttribute('data-speed-mobile') * 1000;
    }
    this.play();
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  autoRotateSlides() {
    var productCount = 0;
    if(window.matchMedia("(min-width: 992px)").matches){
      productCount = parseInt(this.slider.getAttribute('data-desktop-items'));
    } else if (window.matchMedia("(max-width: 750px)").matches) {
      productCount = parseInt(this.slider.getAttribute('data-mobile-items'));
    } else {
      productCount = 2;
    }
    if(productCount != 0){
      productCount = productCount - 1;
    }
    const slideScrollPosition = this.currentPage + productCount === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slider__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    const maxScrollLeft = Math.max(0, this.slider.scrollWidth - this.slider.clientWidth);

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }
    
    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1]) || this.slider.scrollLeft >= maxScrollLeft - 1) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');	
    if (!this.sliderControlButtons.length) return;	
    this.sliderControlButtons.forEach(link => {	
      link.classList.remove('slider-counter__link--active');	
      link.removeAttribute('aria-current');	
    });	
    if(this.sliderControlButtons[this.currentPage - 1]){
      this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');	
      this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
  linkToSlide(event) {
    event.preventDefault();
    var productCount = parseInt(this.slider.getAttribute('data-mobile-items'));
    var slideScrollPosition = this.slider.scrollLeft + this.slider.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    if(productCount == 2){
      slideScrollPosition = this.slider.scrollLeft + this.slider.clientWidth / productCount * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    }
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;
    if(this.slider.querySelectorAll('.slideshow__video').length){
      this.videoAutoplay();
    }

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    if(this.sliderControlButtons[this.currentPage - 1]){
      this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
      this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
  videoAutoplay() {
    const sliderAutoPlay = this.slider.querySelectorAll('.slideshow__video');
    sliderAutoPlay.autoplay = true;
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.variantChangeUnsubscriber = undefined;
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      this.toggleAddButton(true, '', false);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });

    this.variantChangeUnsubscriber = subscribe(
      PUB_SUB_EVENTS.variantChange,
      this.handleVariantChange.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.variantChangeUnsubscriber) {
      this.variantChangeUnsubscriber();
    }
  }

  handleVariantChange({ data: { sectionId, html, variant }}) {
    const pickerId = this.id;
    if (!pickerId) return;

    const isMainPicker = pickerId.includes(`-${sectionId}`) && !pickerId.includes('-sticky');
    const isStickyPicker = pickerId.includes(`-${sectionId}-sticky`);

    if (!isMainPicker && !isStickyPicker) return;

    const sourcePicker = html.querySelector(`#${pickerId}`);
    if (!sourcePicker) return;

    this.updatePickerInputs(sourcePicker);
    this.updateAddToCartButton(variant, html, sectionId);
  }

  updatePickerInputs(sourcePicker) {
    const currentInputs = this.querySelectorAll('input[type="radio"], select option');
    const sourceInputs = sourcePicker.querySelectorAll('input[type="radio"], select option');

    sourceInputs.forEach((sourceInput, index) => {
      const currentInput = currentInputs[index];
      if (!currentInput) return;

      if (sourceInput.classList.contains('disabled')) {
        currentInput.classList.add('disabled');
      } else {
        currentInput.classList.remove('disabled');
      }

      if (currentInput.tagName === 'OPTION') {
        currentInput.innerText = sourceInput.innerText;
        currentInput.disabled = sourceInput.disabled;
      } else if (sourceInput.hasAttribute('aria-label')) {
        currentInput.setAttribute('aria-label', sourceInput.getAttribute('aria-label'));
        // Mirror only response-owned radio label copy; retain input/label identity.
        if (currentInput.type !== 'radio' || sourceInput.type !== 'radio' ||
            !currentInput.dataset.optionValueId ||
            currentInput.dataset.optionValueId !== sourceInput.dataset.optionValueId ||
            !currentInput.id || currentInput.id !== sourceInput.id ||
            currentInput.name !== sourceInput.name || currentInput.value !== sourceInput.value) return;
        const ownedLabels = (input, picker) => Array.from(input.labels || []).filter(
          label => label.htmlFor === input.id && picker.contains(label)
        );
        const currentLabels = ownedLabels(currentInput, this);
        const sourceLabels = ownedLabels(sourceInput, sourcePicker);
        if (currentLabels.length !== 1 || sourceLabels.length !== 1) return;
        const currentLabel = currentLabels[0], sourceLabel = sourceLabels[0];
        const isSwatch = currentLabel.classList.contains('color__swatches');
        if (isSwatch !== sourceLabel.classList.contains('color__swatches')) return;
        const hiddenSpans = label => Array.from(label.children).filter(
          child => child.tagName === 'SPAN' && child.classList.contains('visually-hidden')
        );
        const currentSpans = hiddenSpans(currentLabel), sourceSpans = hiddenSpans(sourceLabel);
        if (currentSpans.length > 1 || sourceSpans.length > 1 || (isSwatch && !sourceSpans.length)) return;
        if (sourceSpans.length) {
          const span = currentSpans[0] || currentLabel.ownerDocument.createElement('span');
          if (!currentSpans.length) span.className = 'visually-hidden';
          if (span.textContent !== sourceSpans[0].textContent) span.textContent = sourceSpans[0].textContent;
          if (!currentSpans.length) currentLabel.appendChild(span);
        } else if (currentSpans.length) {
          currentSpans[0].remove();
        }
      }
    });
  }

  updateAddToCartButton(variant, html, sectionId) {
    if (!this.dataset.section) return;

    const isMainPicker = this.id === `variant-selects-${this.dataset.section}` || this.id === `variant-radios-${this.dataset.section}`;

    if (!isMainPicker) return;

    const addButton = html.getElementById(`ProductSubmitButton-${sectionId}`);

    if (!variant) {
      this.toggleAddButton(true, window.variantStrings.unavailable);
    } else if (addButton && addButton.hasAttribute('disabled')) {
      this.toggleAddButton(true, window.variantStrings.soldOut);
    } else if (document.getElementById(`Quantity-${this.dataset.section}`)?.max === '0') {
      this.toggleAddButton(true, addButton?.dataset.quantityLimitText || window.variantStrings.unavailable);
    } else {
      this.toggleAddButton(false);
    }
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const selectedOption = Array.from(target.options).find((option) => option.getAttribute('selected'));
      if (selectedOption) {
        selectedOption.removeAttribute('selected');
      }
      target.selectedOptions[0].setAttribute('selected', 'selected');
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.textContent = value;

      const optionIndex = target.name.split('-').pop();
      const selectedValueDisplay = this.querySelector(`.selected__value[data-option-index="${optionIndex}"]`);
      if (selectedValueDisplay) {
        selectedValueDisplay.textContent = `(${value})`;
      }
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    const productInfo = document.getElementById(`ProductInfo-${this.dataset.section}`);
    if (productInfo?.dataset.otfNeedsSize === 'true') {
      disable = true;
      text = productInfo.dataset.otfChooseSize;
    }
    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.removeAttribute('aria-disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }
    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

function createImageElement(media, classes, sizes) {
    const previewImage = media["preview_image"], image = new Image(previewImage["width"], previewImage["height"]);
    image.className = classes;
    image.alt = media["alt"];
    image.sizes = sizes;
    image.src = previewImage["src"];
    image.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
    return image;
}
function isHttpsUrl(url) {
  return url.startsWith("https://");
}
function generateSrcset(imageObject, widths = []) {
  var imageUrl = '';
  if (!isHttpsUrl(imageObject["src"])) {
     imageUrl = new URL("https://" + imageObject["src"]);
  }else{
     imageUrl = new URL(imageObject["src"]);
  }
  return widths.filter((width) => width <= imageObject["width"]).map((width) => {
    imageUrl.searchParams.set("width", width.toString());
    return `${imageUrl.href} ${width}w`;
  }).join(", ");
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
(() => {
  if (window.otfCardPhotos) return;
  const CARD = '.otf-catalog-card[data-otf-photo-scope="pink-reviewed-v1"],.otf-catalog-card[data-otf-photo-scope="reviewed-pair-v1"]';
  const hoverQuery = window.matchMedia('(min-width: 1024px) and (hover: hover) and (pointer: fine)');
  const states = new WeakMap();
  const bound = new WeakSet();
  const pairs = [{ handle: '2theworld-barbed-wire-sweatsuit', color: 'Pink', primary: '62630121177269', secondary: '62630121210037' }];
  const swipeMinimum = 32;
  const swipeRatio = 1.5;
  const preloadQueue = [];
  let preloadActive = 0;
  const preloadObserver = typeof IntersectionObserver === 'function' ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const state = states.get(entry.target);
      if (queuePreload(state)) preloadObserver.unobserve(entry.target);
    });
  }, { rootMargin: '1000px 0px', threshold: 0 }) : null;

  function canPreload() {
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    return !document.hidden && !connection?.saveData && !/^(slow-2g|2g|3g)$/.test(connection?.effectiveType || '');
  }

  function queuePreload(state) {
    if (!state || !canPreload() || !active(state) || !state.pair || state.failed) return false;
    if (state.loading || state.secondaryReady || preloadQueue.includes(state)) return true;
    if (preloadQueue.length >= 6) return false;
    preloadQueue.push(state);
    drainPreloads();
    return true;
  }

  function drainPreloads() {
    if (!canPreload()) return;
    while (preloadActive < 2 && preloadQueue.length) {
      const state = preloadQueue.shift();
      if (!active(state) || !state.pair || state.failed || state.loading || state.secondaryReady) continue;
      preloadActive++;
      loadSecondary(state, true).finally(() => {
        preloadActive--;
        drainPreloads();
      });
    }
  }

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) drainPreloads();
  });

  function parse(value) {
    try { return value ? JSON.parse(value) : null; } catch { return null; }
  }

  function imageUrl(media, width) {
    const image = media?.preview_image;
    if (!image?.src || !(Number(image.width) > 0) || !(Number(image.height) > 0) || media.media_type !== 'image') return null;
    try {
      const url = new URL(image.src, location.origin);
      if (url.protocol !== 'https:') return null;
      if (width) url.searchParams.set('width', String(width));
      return url.href;
    } catch { return null; }
  }

  function verified(card, swatch, primary, secondary) {
    if (!imageUrl(primary) || !imageUrl(secondary)) return false;
    if (card.dataset.otfPhotoScope === 'reviewed-pair-v1') {
      const approvedPair = swatch ? swatch.dataset.otfPhotoPair : card.dataset.otfPhotoPair;
      const ids = typeof approvedPair === 'string' && /^(\d+)\|(\d+)$/.exec(approvedPair);
      return Boolean(ids && ids[1] !== ids[2] && ids[1] === String(primary.id) && ids[2] === String(secondary.id));
    }
    const color = swatch ? swatch.value : card.dataset.otfPhotoColor;
    return Boolean(pairs.some(pair =>
      pair.handle === card.dataset.otfProductHandle && pair.color === color &&
      pair.primary === String(primary?.id) && pair.secondary === String(secondary?.id)
    ));
  }

  function buildImage(media, sizes, alt, loading) {
    const image = new Image(Number(media.preview_image.width), Number(media.preview_image.height));
    image.className = 'motion-reduce otf-card-photo-image';
    image.alt = alt;
    image.sizes = sizes;
    image.loading = loading;
    image.decoding = 'async';
    return image;
  }

  function sourceImage(image, media) {
    const widths = [165, 360, 533, 720, 940, 1066].filter(width => width <= Number(media.preview_image.width));
    image.srcset = widths.map(width => `${imageUrl(media, width)} ${width}w`).join(', ');
    image.src = imageUrl(media, Math.min(533, Number(media.preview_image.width)));
  }

  function active(state) {
    if (states.get(state.card) !== state || !state.card.isConnected) return false;
    const checked = state.card.querySelector('.radio-card-swatch:checked');
    return checked === state.swatch && (!checked || (checked.value === state.color &&
      checked.dataset.variantMedia === state.primaryValue && checked.dataset.variantSecondaryMedia === state.secondaryValue)) &&
      (!state.fallbackSecondaryValue || (state.card.dataset.otfPhotoColor === state.color &&
        state.card.dataset.otfPrimaryMediaId === String(state.primaryMedia?.id) &&
        state.card.dataset.otfPhotoSecondaryMedia === state.fallbackSecondaryValue));
  }

  function railOf(card) {
    for (let parent = card.parentElement; parent && parent !== document.body; parent = parent.parentElement) {
      if (/^(auto|scroll)$/.test(getComputedStyle(parent).overflowX) &&
        (parent.scrollWidth > parent.clientWidth + 1 || parent.clientWidth === 0)) return parent;
    }
    return null;
  }

  function classify(card) {
    card.dataset.otfPhotoSwipe = railOf(card) ? 'rail' : 'grid';
  }

  function positionText(state, current, total) {
    return (state.card.dataset.otfPhotoPositionLabel || '[current] / [total]')
      .replaceAll('[current]', String(current)).replaceAll('[total]', String(total));
  }

  function paint(state) {
    if (!active(state)) return;
    const alternate = Boolean(!state.failed && state.pair && state.secondaryReady && (state.pinned || state.hovered));
    const current = alternate ? 2 : 1;
    const total = state.pair ? 2 : 1;
    state.frame.dataset.otfPhotoView = String(current);
    state.primary?.setAttribute('aria-hidden', alternate ? 'true' : 'false');
    state.secondary?.setAttribute('aria-hidden', alternate ? 'false' : 'true');
    if (state.control === state.button) state.button.setAttribute('aria-pressed', String(state.pinned));
    else state.button.removeAttribute('aria-pressed');
    state.button.setAttribute('aria-busy', String(Boolean(state.loading && (state.pinned || state.hovered))));
    state.button.querySelectorAll('[data-otf-photo-mark]').forEach((mark, index) => {
      mark.toggleAttribute('data-on', index === current - 1);
      mark.toggleAttribute('data-next', Boolean(state.loading && (state.pinned || state.hovered) && index === 1));
      mark.hidden = index >= total;
    });
    const target = alternate ? state.card.dataset.otfPhotoPrimary : state.card.dataset.otfPhotoSecond;
    const next = state.card.dataset.otfPhotoNextLabel;
    state.button.setAttribute('aria-label', `${next ? `${next}: ` : ''}${target || ''} — ${state.description}`);
    const position = positionText(state, current, total);
    if (state.position) state.position.textContent = position;
    if (state.announceTarget === current && !state.failed) {
      state.status.textContent = `${state.description} — ${position}`;
      state.announceTarget = null;
    }
  }

  function unavailable(state) {
    if (!active(state)) return;
    state.failed = true;
    state.pair = false;
    state.frame.replaceChildren();
    state.control.hidden = true;
    state.missing.hidden = false;
    state.missing.textContent = `${state.card.dataset.otfPhotoUnavailable}${state.color ? ` (${state.color})` : ''}`;
  }

  function loadSecondary(state, speculative = false) {
    if (!active(state) || !state.pair || state.secondaryReady || state.failed) return Promise.resolve(false);
    if (state.loading) {
      if (!speculative && state.secondary && 'fetchPriority' in state.secondary) state.secondary.fetchPriority = 'auto';
      return state.secondaryTask;
    }
    state.loading = true;
    let finish;
    state.secondaryTask = new Promise(resolve => { finish = resolve; });
    const image = buildImage(state.secondaryMedia, state.sizes, `${state.description} — ${state.card.dataset.otfPhotoSecond}`, 'eager');
    if ('fetchPriority' in image) image.fetchPriority = speculative ? 'low' : 'auto';
    state.secondary = image;
    image.setAttribute('aria-hidden', 'true');
    const failed = () => {
      if (!active(state) || state.failed) { finish(false); return; }
        const requested = state.announceTarget === 2 || state.pinned;
      state.loading = false;
      state.pair = false;
      state.pinned = false;
      state.hovered = false;
      state.announceTarget = null;
      paint(state);
      state.button.setAttribute('aria-disabled', 'true');
      state.button.setAttribute('aria-label', `${state.card.dataset.otfPhotoSecondUnavailable} — ${state.description}`);
      state.control.hidden = document.activeElement !== state.button;
      if (requested) state.status.textContent = state.card.dataset.otfPhotoSecondUnavailable;
      finish(false);
    };
    image.onload = async () => {
      if (!active(state) || state.failed) { finish(false); return; }
      try {
        if (typeof image.decode === 'function') await image.decode();
      } catch {
        failed();
        return;
      }
      if (!active(state) || state.failed) { finish(false); return; }
      state.frame.appendChild(image);
      try {
        await window.otfProductCutouts?.prepare?.(image);
      } catch {}
      if (!active(state) || state.failed) { finish(false); return; }
      state.loading = false;
      state.secondaryReady = true;
      paint(state);
      finish(true);
    };
    image.onerror = failed;
    sourceImage(image, state.secondaryMedia);
    paint(state);
    return state.secondaryTask;
  }

  function release(card) {
    const state = states.get(card);
    if (!state) return;
    preloadObserver?.unobserve(card);
    states.delete(card);
    delete state.frame.dataset.otfPhotoView;
    delete card.dataset.otfPhotoSwipe;
    state.secondary?.remove();
    state.primary?.removeAttribute('aria-hidden');
    if (state.primary && !state.frame.querySelector('img')) state.frame.appendChild(state.primary);
    if (state.primary) state.primary.onerror = state.nativePrimaryError;
    state.control.hidden = true;
    state.button.removeAttribute('aria-disabled');
    state.button.removeAttribute('aria-busy');
    if (state.control === state.button) state.button.setAttribute('aria-pressed', 'false');
    else state.button.removeAttribute('aria-pressed');
    state.missing.hidden = true;
    state.status.textContent = '';
  }

  function update(card, primaryValue, secondaryValue, initial = false) {
    if (!card?.matches(CARD)) {
      if (card) release(card);
      return false;
    }
    const frame = card.querySelector('.card__media .media');
    const button = card.querySelector('[data-otf-photo-toggle]');
    const control = card.querySelector('[data-otf-photo-control]') || button;
    const missing = card.querySelector('[data-otf-photo-missing]');
    const status = card.querySelector('[data-otf-photo-status]');
    if (!frame || !button || !control || !missing || !status) return false;
    const swatch = card.querySelector('.radio-card-swatch:checked');
    const primarySource = swatch ? swatch.dataset.variantMedia : primaryValue ?? card.dataset.otfPhotoPrimaryMedia;
    const current = frame.querySelector('img');
    if (initial && control === button && !swatch && !primarySource && current &&
      card.dataset.otfPhotoScope === 'pink-reviewed-v1' && pairs.some(pair =>
        pair.handle === card.dataset.otfProductHandle && pair.primary === card.dataset.otfPrimaryMediaId)) {
      button.hidden = true;
      missing.hidden = true;
      status.textContent = '';
      return true;
    }
    const primaryMedia = parse(primarySource);
    let secondarySource = swatch ? swatch.dataset.variantSecondaryMedia : secondaryValue ?? card.dataset.otfPhotoSecondaryMedia;
    let fallbackSecondaryValue;
    if (swatch && !secondarySource && card.dataset.otfPhotoScope === 'pink-reviewed-v1' &&
      swatch.value === card.dataset.otfPhotoColor && String(primaryMedia?.id) === card.dataset.otfPrimaryMediaId) {
      secondarySource = card.dataset.otfPhotoSecondaryMedia;
      fallbackSecondaryValue = secondarySource;
    }
    const secondaryMedia = parse(secondarySource);
    const pair = card.dataset.secondaryImage === 'true' && verified(card, swatch, primaryMedia, secondaryMedia);
    const previous = states.get(card);
    const color = swatch ? swatch.value : card.dataset.otfPhotoColor || '';
    const description = `${card.dataset.otfProductTitle}${color ? ` — ${color}` : ''}`;
    const state = { card, frame, button, control, missing, status, swatch, color, description, primaryMedia, secondaryMedia,
      primaryValue: swatch?.dataset.variantMedia, secondaryValue: swatch?.dataset.variantSecondaryMedia, fallbackSecondaryValue,
      position: card.querySelector('[data-otf-photo-position]'), sizes: current?.sizes || previous?.sizes || '',
      pinned: false, hovered: false, loading: false, secondaryReady: false, announceTarget: null, pair, failed: false,
      nativePrimaryError: previous ? previous.nativePrimaryError : current?.onerror };
    states.set(card, state);
    frame.classList.remove('media--hover-effect');
    missing.hidden = true;
    status.textContent = '';
    control.hidden = !pair;
    button.hidden = false;
    button.removeAttribute('aria-disabled');
    frame.dataset.otfPhotoView = '1';
    classify(card);
    if (!imageUrl(primaryMedia)) {
      unavailable(state);
      return true;
    }
    const preserve = initial && current && String(primaryMedia.id) === card.dataset.otfPrimaryMediaId;
    state.primary = preserve ? current : buildImage(primaryMedia, state.sizes, '', current?.loading || 'lazy');
    state.primary.alt = `${description} — ${card.dataset.otfPhotoPrimary}`;
    state.primary.onerror = () => unavailable(state);
    frame.replaceChildren(state.primary);
    if (!preserve) sourceImage(state.primary, primaryMedia);
    else if (state.primary.complete && !state.primary.naturalWidth) unavailable(state);
    paint(state);
    if (pair && canPreload()) preloadObserver?.observe(card);
    return true;
  }

  function choose(state, alternate) {
    if (!active(state) || !state.pair || state.failed) return;
    if (state.pinned === alternate && !state.hovered) return;
    state.pinned = alternate;
    state.hovered = false;
    state.announceTarget = alternate ? 2 : 1;
    if (alternate) loadSecondary(state);
    paint(state);
  }

  function init(card) {
    if (card.dataset.secondaryImage !== 'true') return;
    const inner = card.querySelector('.card__inner');
    const button = card.querySelector('[data-otf-photo-toggle]');
    const photoLink = inner?.querySelector(':scope > .media-full-unstyled-link');
    if (!inner || !button) return;
    if (!states.has(card)) update(card, undefined, undefined, true);
    classify(card);
    if (bound.has(card)) return;
    bound.add(card);
    let lastPointerType = null;
    const enterPhotoZone = event => {
      const state = states.get(card);
      if (!state?.pair || !active(state)) return;
      let eligible = false;
      if (event.type === 'mouseover') {
        eligible = (lastPointerType === 'touch' || lastPointerType === 'pen') && inner.matches(':hover');
      } else {
        lastPointerType = event.pointerType || lastPointerType;
        if (event.type === 'pointerdown') eligible = event.pointerType === 'touch' || event.pointerType === 'pen';
        else if (event.pointerType === 'mouse') eligible = hoverQuery.matches;
        else eligible = event.currentTarget === inner && (event.pointerType === 'touch' || event.pointerType === 'pen');
      }
      if (!eligible) return;
      state.hovered = true;
      loadSecondary(state);
      paint(state);
    };
    const leavePhotoZone = event => {
      const state = states.get(card);
      if (!state) return;
      if (event.relatedTarget instanceof Node && state.control.contains(event.relatedTarget)) return;
      state.hovered = false;
      paint(state);
    };
    inner.addEventListener('pointerenter', enterPhotoZone);
    inner.addEventListener('pointerdown', enterPhotoZone);
    inner.addEventListener('mouseover', enterPhotoZone);
    inner.addEventListener('pointerleave', leavePhotoZone);
    inner.addEventListener('mouseleave', leavePhotoZone);
    const control = card.querySelector('[data-otf-photo-control]') || button;
    control.addEventListener('pointerenter', enterPhotoZone);
    control.addEventListener('pointerleave', event => {
      const state = states.get(card);
      if (!state || (event.relatedTarget instanceof Node && inner.contains(event.relatedTarget))) return;
      state.hovered = false;
      paint(state);
    });
    button.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      const state = states.get(card);
      if (state && button.getAttribute('aria-disabled') !== 'true') choose(state, state.frame.dataset.otfPhotoView !== '2');
    });
    button.addEventListener('blur', () => {
      const state = states.get(card);
      if (state && !state.pair) state.control.hidden = true;
    });
    if (!photoLink) return;
    let gesture = null;
    let dragClick = null;
    photoLink.addEventListener('pointerover', () => classify(card));
    photoLink.addEventListener('touchstart', event => {
      dragClick = null;
      classify(card);
      const state = states.get(card);
      if (event.touches.length !== 1 || !state?.pair || !active(state) || railOf(card)) {
        gesture = null;
        return;
      }
      const touch = event.touches[0];
      gesture = { id: touch.identifier, x: touch.clientX, y: touch.clientY, state, horizontal: false, vertical: false };
    }, { passive: true });
    photoLink.addEventListener('touchmove', event => {
      if (!gesture || !active(gesture.state)) return;
      if (event.touches.length !== 1) { gesture = null; return; }
      const touch = event.touches[0];
      if (touch.identifier !== gesture.id) { gesture = null; return; }
      const dx = touch.clientX - gesture.x;
      const dy = touch.clientY - gesture.y;
      if (Math.abs(dy) >= 12 && Math.abs(dy) >= Math.abs(dx)) {
        gesture.vertical = true;
        gesture.horizontal = false;
      }
      if (gesture.vertical) return;
      if (!gesture.horizontal && Math.abs(dx) >= swipeMinimum && Math.abs(dx) >= swipeRatio * Math.abs(dy)) gesture.horizontal = true;
      if (gesture.horizontal && event.cancelable) event.preventDefault();
    }, { passive: false });
    photoLink.addEventListener('touchend', event => {
      if (!gesture) return;
      const completed = gesture;
      gesture = null;
      if (event.touches.length || !completed.horizontal || completed.vertical) return;
      const touch = Array.from(event.changedTouches).find(item => item.identifier === completed.id);
      if (!touch) return;
      const dx = touch.clientX - completed.x;
      const dy = touch.clientY - completed.y;
      dragClick = { expires: performance.now() + 700 };
      if (!active(completed.state) || railOf(card) || Math.abs(dx) < swipeMinimum || Math.abs(dx) < swipeRatio * Math.abs(dy)) return;
      const rtl = getComputedStyle(card).direction === 'rtl';
      choose(completed.state, rtl ? dx > 0 : dx < 0);
    }, { passive: true });
    photoLink.addEventListener('touchcancel', () => { gesture = null; dragClick = null; }, { passive: true });
    photoLink.addEventListener('click', event => {
      if (!dragClick || event.detail === 0 || performance.now() > dragClick.expires ||
        (event.pointerType && event.pointerType !== 'touch')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      dragClick = null;
    }, true);
  }

  function scan(root = document) {
    if (root.matches?.(CARD)) init(root);
    root.querySelectorAll?.(CARD).forEach(init);
  }

  function start() {
    scan();
    new MutationObserver(mutations => mutations.forEach(mutation => mutation.addedNodes.forEach(node => {
      if (node instanceof Element) scan(node);
    }))).observe(document.body, { childList: true, subtree: true });
  }

  let resizeFrame;
  window.addEventListener('resize', () => {
    if (resizeFrame) return;
    resizeFrame = requestAnimationFrame(() => {
      resizeFrame = null;
      document.querySelectorAll(CARD).forEach(classify);
    });
  }, { passive: true });
  window.otfCardPhotos = { update };
  hoverQuery.addEventListener('change', () => document.querySelectorAll(CARD).forEach(card => {
    const state = states.get(card);
    if (state) { state.hovered = false; paint(state); }
  }));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.matches?.(CARD)) release(event.target);
    event.target.querySelectorAll?.(CARD).forEach(release);
  });
})();

customJavascript();
window.matchMedia('(max-width: 990px)').addEventListener('change', (event) => {
  if (!event.matches) document.documentElement.style.removeProperty('--viewport-height');
});


/* Product photo previews for custom and horizontal cards. */
(() => {
  if (window.otfCustomCardPhotos) return;
  const HOST = '[data-otf-custom-photo]';
  const states = new WeakMap();
  const bound = new WeakSet();
  const hover = window.matchMedia('(hover: hover) and (pointer: fine)');
  const queue = [];
  let loading = 0;
  let current = null;
  const parse = value => { try { return JSON.parse(value || 'null'); } catch { return null; } };
  function key(value) {
    try {
      const url = new URL(value, location.origin);
      if (url.protocol !== 'https:') return '';
      return decodeURIComponent(url.pathname.split('/').pop()) + (url.searchParams.has('v') ? '?v=' + url.searchParams.get('v') : '');
    } catch { return ''; }
  }
  function usable(media) {
    return Boolean(media?.media_type === 'image' && media.id && key(media.preview_image?.src) &&
      Number(media.preview_image.width) > 0 && Number(media.preview_image.height) > 0);
  }
  function matchesSource(image, media) {
    const expected = key(media?.preview_image?.src);
    const actual = key(image.getAttribute('src'));
    if (!expected || !actual) return false;
    const prepared = window.otfPreparedImages?.[expected]?.url;
    return actual === expected || Boolean(prepared && actual === key(prepared));
  }
  function active(state) {
    if (states.get(state.host) !== state || !state.host.isConnected || !state.primary.isConnected ||
      !matchesSource(state.primary, state.primaryMedia)) return false;
    const checked = state.host.querySelector('.radio-card-swatch:checked');
    return checked === state.swatch && (!checked || (checked.value === state.color &&
      checked.dataset.variantMedia === state.primaryValue && checked.dataset.variantSecondaryMedia === state.secondaryValue &&
      checked.dataset.otfPhotoPair === state.pairValue));
  }
  function nativeHover(state) {
    try { return state.link.matches(':hover'); } catch { return false; }
  }
  function paint(state) {
    if (!active(state)) return;
    const show = !state.blocked && !state.failed && state.ready && (state.intent || nativeHover(state));
    state.frame.dataset.otfCustomPhotoView = show ? '2' : '1';
  }
  function resetIntent() {
    if (!current) return;
    const state = current;
    current = null;
    state.intent = false;
    state.blocked = true;
    paint(state);
  }
  function load(state) {
    if (!active(state) || state.failed || state.ready) return Promise.resolve();
    if (state.task) return state.task;
    let finish;
    state.task = new Promise(resolve => { finish = resolve; });
    const image = new Image(Number(state.secondaryMedia.preview_image.width), Number(state.secondaryMedia.preview_image.height));
    state.secondary = image;
    image.className = state.primary.className + ' otf-custom-photo-secondary';
    image.dataset.otfCustomPhotoSecondary = '';
    image.alt = '';
    image.setAttribute('aria-hidden', 'true');
    image.decoding = 'async';
    image.loading = 'eager';
    image.sizes = state.primary.sizes || '(max-width: 749px) 80vw, 320px';
    const style = getComputedStyle(state.primary);
    image.style.objectFit = style.objectFit || 'contain';
    image.style.objectPosition = style.objectPosition || 'center';
    const fail = () => {
      state.failed = true;
      state.intent = false;
      image.remove();
      if (active(state)) state.frame.dataset.otfCustomPhotoView = '1';
      finish();
    };
    image.onerror = fail;
    image.onload = async () => {
      if (!active(state)) { image.remove(); finish(); return; }
      try { if (typeof image.decode === 'function') await image.decode(); } catch { fail(); return; }
      if (!active(state) || state.failed) { image.remove(); finish(); return; }
      state.frame.appendChild(image);
      try { await window.otfProductCutouts?.prepare?.(image); } catch {}
      if (!active(state) || state.failed) { image.remove(); finish(); return; }
      state.ready = true;
      paint(state);
      finish();
    };
    const src = new URL(state.secondaryMedia.preview_image.src, location.origin);
    const width = Math.min(720, Number(state.secondaryMedia.preview_image.width));
    const widths = [160, 240, 360, 540, 720].filter(value => value <= width);
    image.srcset = widths.map(value => { const url = new URL(src); url.searchParams.set('width', String(value)); return `${url.href} ${value}w`; }).join(', ');
    src.searchParams.set('width', String(width));
    image.src = src.href;
    return state.task;
  }
  function canPreload() {
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    return !document.hidden && !connection?.saveData && !/^(slow-2g|2g|3g)$/.test(connection?.effectiveType || '');
  }
  function drain() {
    if (loading || !canPreload()) return;
    while (queue.length) {
      const state = queue.shift();
      if (!active(state) || state.failed || state.ready || state.task) continue;
      loading = 1;
      load(state).finally(() => { loading = 0; drain(); });
      return;
    }
  }
  const observer = typeof IntersectionObserver === 'function' ? new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting || !canPreload()) continue;
      const state = states.get(entry.target);
      if (!state || !active(state) || state.failed) continue;
      if (state.task || state.ready || queue.includes(state)) { observer.unobserve(entry.target); continue; }
      if (queue.length >= 3) continue;
      queue.push(state);
      observer.unobserve(entry.target);
      drain();
    }
  }, { rootMargin: '160px 0px', threshold: 0 }) : null;
  function release(host) {
    const state = states.get(host);
    if (!state) return;
    states.delete(host);
    if (current === state) current = null;
    state.secondary?.remove();
    state.primary.removeAttribute('data-otf-custom-photo-primary');
    delete state.frame.dataset.otfCustomPhotoView;
    state.frame.removeAttribute('data-otf-custom-photo-frame');
    state.frame.removeAttribute('data-otf-custom-photo-position');
    if (state.legacyHover) state.frame.classList.add('media--hover-effect');
    observer?.unobserve(host);
  }
  function update(host) {
    if (!host?.matches(HOST)) return false;
    release(host);
    const media = host.querySelector('[data-otf-card-media]');
    const inner = host.querySelector('.card__inner');
    const link = media?.querySelector('.otf-card__media-link') || inner?.querySelector(':scope > .media-full-unstyled-link');
    const primary = media ? link?.querySelector('img:not([data-otf-custom-photo-secondary])') : inner?.querySelector('.card__media .media > img:not([data-otf-custom-photo-secondary])');
    if (!link || !primary) return false;
    const swatch = host.querySelector('.radio-card-swatch:checked');
    let primaryMedia = parse(swatch ? swatch.dataset.variantMedia : host.dataset.otfCustomPhotoPrimaryMedia);
    let secondaryMedia = parse(swatch ? swatch.dataset.variantSecondaryMedia : host.dataset.otfCustomPhotoSecondaryMedia);
    let pairValue = swatch ? swatch.dataset.otfPhotoPair : host.dataset.otfCustomPhotoPair;
    const color = swatch?.value || host.dataset.otfCardColor || host.dataset.otfCustomPhotoColor || '';
    if (swatch && !pairValue && color === host.dataset.otfCustomPhotoColor &&
      String(primaryMedia?.id) === String(parse(host.dataset.otfCustomPhotoPrimaryMedia)?.id)) {
      pairValue = host.dataset.otfCustomPhotoPair;
      secondaryMedia = parse(host.dataset.otfCustomPhotoSecondaryMedia);
    }
    const ids = /^(\d+)\|(\d+)$/.exec(pairValue || '');
    if (!usable(primaryMedia) || !usable(secondaryMedia) || !ids || ids[1] === ids[2] ||
      ids[1] !== String(primaryMedia.id) || ids[2] !== String(secondaryMedia.id) || !matchesSource(primary, primaryMedia)) return false;
    if (swatch?.dataset.productUrl) {
      try { if (new URL(swatch.dataset.productUrl, location.origin).pathname !== new URL(host.dataset.url, location.origin).pathname) return false; } catch { return false; }
    }
    const frame = primary.closest('picture')?.parentElement || primary.parentElement;
    const state = { host, link, primary, frame, swatch, color, primaryMedia, secondaryMedia, ready: false, failed: false, intent: false, blocked: false,
      legacyHover: frame.classList.contains('media--hover-effect'),
      primaryValue: swatch?.dataset.variantMedia, secondaryValue: swatch?.dataset.variantSecondaryMedia,
      pairValue: swatch?.dataset.otfPhotoPair };
    states.set(host, state);
    frame.classList.remove('media--hover-effect');
    primary.dataset.otfCustomPhotoPrimary = '';
    frame.dataset.otfCustomPhotoFrame = '';
    if (!getComputedStyle(frame).position || getComputedStyle(frame).position === 'static') frame.dataset.otfCustomPhotoPosition = '';
    frame.dataset.otfCustomPhotoView = '1';
    if (!bound.has(link)) {
      bound.add(link);
      const enter = event => {
        const state = states.get(host);
        if (!state || !active(state) || state.failed || (event.pointerType === 'mouse' && !hover.matches)) return;
        if (current && current !== state) resetIntent();
        current = state;
        state.blocked = false;
        state.intent = true;
        load(state);
        paint(state);
      };
      const exit = event => {
        const state = states.get(host);
        if (state) {
          state.intent = false;
          if (event?.type !== 'pointerup') state.blocked = true;
          paint(state);
        }
      };
      link.addEventListener('pointerenter', enter);
      link.addEventListener('pointerdown', enter);
      link.addEventListener('pointerleave', exit);
      link.addEventListener('pointercancel', exit);
      link.addEventListener('pointerup', exit);
      link.addEventListener('mouseover', event => { const state = states.get(host); if (state && nativeHover(state)) enter(event); });
      link.addEventListener('mouseout', event => { if (!(event.relatedTarget instanceof Node) || !link.contains(event.relatedTarget)) exit(event); });
    }
    observer?.observe(host);
    return true;
  }
  function scan(root = document) {
    if (root.matches?.(HOST)) update(root);
    root.querySelectorAll?.(HOST).forEach(update);
  }
  window.otfCustomCardPhotos = { update };
  function start() {
    scan();
    new MutationObserver(mutations => {
      for (const mutation of mutations) for (const node of mutation.addedNodes) if (node instanceof Element) scan(node);
    }).observe(document.body, { childList: true, subtree: true });
  }
  document.addEventListener('pointerdown', event => { if (current && !current.link.contains(event.target)) resetIntent(); }, { capture: true, passive: true });
  document.addEventListener('visibilitychange', () => { if (document.hidden) resetIntent(); else drain(); });
  window.addEventListener('blur', resetIntent);
  window.addEventListener('pagehide', resetIntent);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.matches?.(HOST)) release(event.target);
    event.target.querySelectorAll?.(HOST).forEach(release);
  });
})();
